import { JSX, useEffect } from "react";
import { useNavigate } from "react-router";

export default function ProtectedRoute({
  children,
}: {
  children: JSX.Element;
}) {
  const navigate = useNavigate();

  useEffect(() => {
    fetch("/api/check", {
      credentials: "include",
    }).then((res) => {
      if (!res.ok) navigate("/user/login");
    });
  }, [navigate]);

  return children;
}
